export default "__VITE_ASSET__BxaOTehJ__"